module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n   " + _vm._s(_vm.actionToBePerformed) + "\n  ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/nudge-template/view"
    }
  }, [_vm._v("Back")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.actionToBePerformed))])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-12"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createOrUpdateNudge.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "template_title"
    }
  }, [_vm._v("Template Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.template_title),
      expression: "template_title"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.template_title.required
    },
    attrs: {
      "type": "text",
      "id": "template_title",
      "placeholder": "Template Name"
    },
    domProps: {
      "value": (_vm.template_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.template_title = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.template_title.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter template name.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "turn_country"
    }
  }, [_vm._v("WhatsApp Account (Country)")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "id": "turn_country"
    },
    on: {
      "change": function($event) {
        return _vm.onTurnCountryChange()
      }
    },
    model: {
      value: (_vm.turnCountry),
      callback: function($$v) {
        _vm.turnCountry = $$v
      },
      expression: "turnCountry"
    }
  }, _vm._l((_vm.countryList), function(country) {
    return _c('option', {
      key: country,
      domProps: {
        "value": country
      }
    }, [_vm._v(_vm._s(country))])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Each country uses its own Turn namespace, so the approved templates below differ per country.")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Language")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.addOrUpdateSubmit && !_vm.nudgeSet.language_id
    },
    model: {
      value: (_vm.nudgeSet.language_id),
      callback: function($$v) {
        _vm.$set(_vm.nudgeSet, "language_id", $$v)
      },
      expression: "nudgeSet.language_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose language--")]), _vm._v(" "), _vm._l((_vm.languages), function(value, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": value.id
      }
    }, [_vm._v("\n                                    " + _vm._s(value.full_name))])
  })], 2), _vm._v(" "), (_vm.addOrUpdateSubmit && !_vm.nudgeSet.language_id) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please select language.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "turn_template_name"
    }
  }, [_vm._v("WhatsApp Turn template name")]), _vm._v(" "), _c('treeselect', {
    class: {
      'form-group--error': _vm.addOrUpdateSubmit && !_vm.nudgeSet.turn_template_name
    },
    attrs: {
      "placeholder": "--Choose a template--",
      "multiple": false,
      "options": _vm.turnTemplateList
    },
    model: {
      value: (_vm.nudgeSet.turn_template_name),
      callback: function($$v) {
        _vm.$set(_vm.nudgeSet, "turn_template_name", $$v)
      },
      expression: "nudgeSet.turn_template_name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "display-content"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nudgeSet.is_dynamic_template),
      expression: "nudgeSet.is_dynamic_template"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.nudgeSet.is_dynamic_template) ? _vm._i(_vm.nudgeSet.is_dynamic_template, null) > -1 : (_vm.nudgeSet.is_dynamic_template)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.nudgeSet.is_dynamic_template,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.nudgeSet, "is_dynamic_template", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.nudgeSet, "is_dynamic_template", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.nudgeSet, "is_dynamic_template", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v("Is Dynamic Template?")]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), (_vm.checkIfTemplateHasMedia(_vm.nudgeSet.turn_template_name)) ? _c('div', {
    staticClass: "display-content"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "media_id"
    }
  }, [_vm._v("Select Uploaded Media")]), _vm._v(" "), _c('treeselect', {
    class: {
      'form-group--error': _vm.addOrUpdateSubmit && !_vm.nudgeSet.media_id
    },
    attrs: {
      "placeholder": "--Choose a media--",
      "multiple": false,
      "options": _vm.mediaList
    },
    model: {
      value: (_vm.nudgeSet.media_id),
      callback: function($$v) {
        _vm.$set(_vm.nudgeSet, "media_id", $$v)
      },
      expression: "nudgeSet.media_id"
    }
  }), _vm._v(" "), (_vm.nudgeSet.media_id) ? _c('media-preview', {
    attrs: {
      "compact": "",
      "format": _vm.mediaFormatOf(_vm.nudgeSet.media_id) || _vm.headerFormatOf(_vm.nudgeSet.turn_template_name),
      "media-id": _vm.nudgeSet.media_id,
      "media-name": _vm.mediaLabel(_vm.nudgeSet.media_id),
      "missing-text": ": no stored file"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mediaMismatch(_vm.nudgeSet)) ? _c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.mediaMismatch(_vm.nudgeSet)))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.nudgeSet.turn_template_name) ? _c('div', {
    staticClass: "display-content"
  }, [_c('b', [_vm._v("Content: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getTurnDisplayText(_vm.nudgeSet.turn_template_name)))])]) : _vm._e(), _vm._v(" "), (_vm.addOrUpdateSubmit && !_vm.nudgeSet.turn_template_name) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter turn template name.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-4 col-xs-4"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "legacy_name"
    }
  }, [_vm._v("Facebook Nudge Content")]), _vm._v(" "), _c('div', {
    staticClass: "fb-nudge-container"
  }, [_c('span', {
    staticClass: "fb-nudge-text"
  }, [_vm._v("Title: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nudgeSet.fb_nudge_title),
      expression: "nudgeSet.fb_nudge_title"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "text",
      "id": "legacy_name",
      "placeholder": "Enter Title"
    },
    domProps: {
      "value": (_vm.nudgeSet.fb_nudge_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nudgeSet, "fb_nudge_title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fb-nudge-container"
  }, [_c('span', {
    staticClass: "fb-nudge-text"
  }, [_vm._v("Image Url: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nudgeSet.fb_nudge_image),
      expression: "nudgeSet.fb_nudge_image"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "text",
      "id": "legacy_name",
      "placeholder": "Enter Image URL"
    },
    domProps: {
      "value": (_vm.nudgeSet.fb_nudge_image)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nudgeSet, "fb_nudge_image", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fb-nudge-container"
  }, [_c('span', {
    staticClass: "fb-nudge-text required"
  }, [_vm._v("Body: ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "width": "100%"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nudgeSet.fb_nudge_text),
      expression: "nudgeSet.fb_nudge_text"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.addOrUpdateSubmit && !_vm.nudgeSet.fb_nudge_text
    },
    attrs: {
      "placeholder": "Enter Body text"
    },
    domProps: {
      "value": (_vm.nudgeSet.fb_nudge_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nudgeSet, "fb_nudge_text", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.addOrUpdateSubmit && !_vm.nudgeSet.fb_nudge_text) ? _c('span', {
    staticClass: "text-red pull-right",
    staticStyle: {
      "align-self": "end"
    }
  }, [_vm._v("Please enter Facebook body text.")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "action-button",
    staticStyle: {
      "margin": "25px"
    }
  }, [_c('input', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button",
      "value": _vm.nudge_btn_text
    },
    on: {
      "click": function($event) {
        return _vm.addOrUpdateText()
      }
    }
  })]), _vm._v(" "), (_vm.nudges.length) ? _c('table', {
    staticClass: "table table-striped margin-top-20"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.nudges), function(nudge, key) {
    return _c('tr', {
      key: key
    }, [_c('td', {
      staticStyle: {
        "width": "10%",
        "background-color": "#e8e8e8"
      }
    }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.languages.find(function (item) { return item.id === nudge.language_id; }).full_name))])])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "40%"
      }
    }, [_c('span', {
      staticClass: "fb-nudge-text"
    }, [_vm._v("Name: ")]), _vm._v(" " + _vm._s(nudge.turn_template_name) + "\n                                    "), _c('span', {
      staticClass: "fb-nudge-text"
    }, [_vm._v("Dynamic: ")]), _vm._v(" " + _vm._s(nudge.is_dynamic_template ? 'Yes' : 'No') + "\n                                    "), _c('span', {
      staticClass: "fb-nudge-text"
    }, [_vm._v("Media: ")]), _vm._v(" " + _vm._s(nudge.media_id ? _vm.mediaLabel(nudge.media_id) : 'No Media') + "\n                                    "), (nudge.media_id) ? _c('media-preview', {
      attrs: {
        "compact": "",
        "show-caption": false,
        "format": _vm.mediaFormatOf(nudge.media_id) || _vm.headerFormatOf(nudge.turn_template_name),
        "media-id": nudge.media_id,
        "media-name": _vm.mediaLabel(nudge.media_id),
        "missing-text": ": no stored file"
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "fb-nudge-text"
    }, [_vm._v("Content: ")]), _vm._v(" " + _vm._s(_vm.getTurnDisplayText(nudge.turn_template_name)) + "\n                                  ")], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "40%"
      }
    }, [_c('span', {
      staticClass: "fb-nudge-text"
    }, [_vm._v("Title: ")]), _vm._v(" " + _vm._s(nudge.fb_nudge_title) + "\n                                    "), _c('span', {
      staticClass: "fb-nudge-text"
    }, [_vm._v("Image: ")]), _vm._v(" " + _vm._s(nudge.fb_nudge_image) + "\n                                    "), _c('span', {
      staticClass: "fb-nudge-text"
    }, [_vm._v("Body: ")]), _vm._v(" " + _vm._s(nudge.fb_nudge_text) + "\n                                  ")]), _vm._v(" "), _c('td', {
      staticClass: "align-center",
      staticStyle: {
        "width": "5%"
      }
    }, [_c('i', {
      staticClass: "fa fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.editNudge(key)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "align-center",
      staticStyle: {
        "width": "5%"
      }
    }, [_c('i', {
      staticClass: "fa fa-times-circle",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.deleteNudge(key)
        }
      }
    })])])
  }), 0)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "action-button"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.template_id ? 'Update Nudge' : 'Save Nudge'
    }
  })])])])])])])])])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Match Template & Content")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "title": "Ensure that this option is checked only if the template is dynamic, as it will replace the arguments in the message with the actual text that we provide during configuration"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle margin-10"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', {
    staticClass: "width-100"
  }, [_vm._v("Language")]), _vm._v(" "), _c('th', [_vm._v("WhatsApp Approved Templates")]), _vm._v(" "), _c('th', [_vm._v("Facebook Messenger Content")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Edit")]), _vm._v(" "), _c('th', {
    staticClass: "align-center"
  }, [_vm._v("Delete")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-163ca922","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nudge-template-manager/createOrUpdateNudgeTemplate.vue
// module id = awRc
// module chunks = 1